import { main } from './character/main.es6';

document.addEventListener('DOMContentLoaded', main);
